/* eslint-disable @typescript-eslint/typedef */

/**
 * @desc Vulnerability API query parameter constants
 * Centralized query parameter keys for vulnerability-related endpoints
 */
export const VulnerabilityQueryParams = {
  /** Interval type for vulnerability trends (week or month) */
  INTERVAL_TYPE: 'intervalType',

  /** Number of intervals to fetch for trends */
  NUMBER_OF_INTERVALS: 'numberOfIntervals',

  /** Whether to fetch open vulnerabilities for trends */
  OPEN_WANTED: 'openWanted',

  /** Number of top targets to retrieve */
  NUMBER_OF_TARGETS: 'numberOfTargets'
} as const;
